(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["num-txt-col-with-images"] && !Shopify.designMode) return;
  try {
    

// title
// subtitle
// prosDiv
// consDiv

function getMaxHeight(className) {
  var max = 0;
  document.querySelectorAll(className).forEach(
    function(el) {
      console.info(Math.max(el.scrollHeight, max));
      if (el.scrollHeight > max) {
        max = el.scrollHeight;
      }
    }
  );
  
  return max;
}

function setHeight(className, height) {
  document.querySelectorAll(className).forEach(
    function(el) {
      el.style.height = height+'px';
    }
  );
}

setHeight('.title', getMaxHeight('.title'));
setHeight('.subtitle', getMaxHeight('.subtitle'));
setHeight('.prosDiv', getMaxHeight('.prosDiv'));
setHeight('.consDiv', getMaxHeight('.consDiv'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resource-video"] && !Shopify.designMode) return;
  try {
    

function getMaxHeight(className) {
    var max = 0;
    document.querySelectorAll(className).forEach(
        function(el) {
            console.info(Math.max(el.scrollHeight, max));
            if (el.scrollHeight > max) {
                max = el.scrollHeight;
            }
        }
    );

    return max;
}

function setHeight(className, height) {
    document.querySelectorAll(className).forEach(
        function(el) {
            el.style.height = height+'px';
        }
    );
}

setHeight('.set-new-height', getMaxHeight('.set-new-height'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-most-popular"] && !Shopify.designMode) return;
  try {
    

// title
// subtitle
// prosDiv
// consDiv

function getMaxHeight(className) {
  var max = 0;
  document.querySelectorAll(className).forEach(
    function(el) {
      console.info(Math.max(el.scrollHeight, max));
      if (el.scrollHeight > max) {
        max = el.scrollHeight;
      }
    }
  );
  
  return max;
}

function setHeight(className, height) {
  document.querySelectorAll(className).forEach(
    function(el) {
      el.style.height = height+'px';
    }
  );
}

setHeight('.title', getMaxHeight('.title'));
setHeight('.subtitle', getMaxHeight('.subtitle'));
setHeight('.prosDiv', getMaxHeight('.prosDiv'));
setHeight('.consDiv', getMaxHeight('.consDiv'));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-with-images"] && !Shopify.designMode) return;
  try {
    

  // column-image
  // title
  // subtitle
  // text
  // button-row-one

  function getMaxHeight(className) {
  var max = 0;
  document.querySelectorAll(className).forEach(
  function(el) {
  console.info(Math.max(el.scrollHeight, max));
  if (el.scrollHeight > max) {
  max = el.scrollHeight;
  }
  }
  );

  return max;
  }

  function setHeight(className, height) {
  document.querySelectorAll(className).forEach(
  function(el) {
  el.style.height = height+'px';
  }
  );
  }
  let isMobile = false;

  if (navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)) {
  isMobile = true;
  }

  if(isMobile == false){
  //We want same height only if the user is NOT using a mobile
  setHeight('.column-image', getMaxHeight('.column-image'));
  setHeight('.title', getMaxHeight('.title'));
  setHeight('.subtitle', getMaxHeight('.subtitle'));
  setHeight('.text', getMaxHeight('.text'));
  setHeight('.button-row-one', getMaxHeight('.button-row-one'));
  }



  } catch(e) { console.error(e); }
})();
})();
